<template>
    <app-tabela
        idTabela="tblRateios"
        :itens="rateios"
        :campos="campos"
        :itensPorPagina="itensPorPagina"
        :mostrarFiltro="false"
        :bordered="false"
        :small="true"
    >
        <template slot="nuValorRateio" slot-scope="data">{{
            data.nuValorRateio | currency
        }}</template>
        <template slot="unidade" slot-scope="data"
            >({{ data.codUnidade }}) {{ data.unidade }}</template
        >
        <template slot="projeto" slot-scope="data"
            >({{ data.codProjeto }}) {{ data.projeto }}</template
        >
        <template slot="acao" slot-scope="data"
            >({{ data.codAcao }}) {{ data.acao }}</template
        >
        <template slot="botoes">
            <slot name="botoes"></slot>
        </template>
        <template slot="acoes" slot-scope="data">
            <btn-atualizar-dotacao
                v-if="operacao != 'D'"
                :valorTotal="valorASerRateado"
                :valorDisponivel="valorDisponivel"
                :rateio="data"
                @atualizarRateio="$emit('atualizarRateio', $event)"
            ></btn-atualizar-dotacao>
            <btn-excluir-dotacao
                v-if="operacao != 'D'"
                :rateio="data"
                @excluirRateio="$emit('excluirRateio', data)"
            ></btn-excluir-dotacao>
            <btn-saldo-projeto-acao
                :rateio="data"
                :dataMovimento="dataMovimento"
            ></btn-saldo-projeto-acao>
            <slot name="acoes" v-bind="data"></slot>
        </template>
    </app-tabela>
</template>

<script>
import BtnAtualizarDotacao from './BtnAtualizarDotacao'
import BtnExcluirDotacao from './BtnExcluirDotacao'
import BtnSaldoProjetoAcao from './BtnSaldoProjetoAcao'

export default {
    components: {
        BtnAtualizarDotacao,
        BtnExcluirDotacao,
        BtnSaldoProjetoAcao
    },

    props: {
        rateios: {
            type: Array,
            default: () => []
        },

        temAcoes: {
            type: Boolean,
            default: () => false
        },

        valorASerRateado: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        operacao: {
            type: String,
            default: () => 'D'
        },

        dataMovimento: {
            type: String
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: ''
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nuValorRateio',
                    label: 'Valor',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {},

    watch: {},

    created() {}
}
</script>
